'use client';

import React from 'react';
import { CTABand, Heading } from '@ui';
import { withOptionalId } from '@lib/withOptionalId';
import { Section, Container } from '@layout';
import MarkupSnippet, { markupCopyLabels } from '../markup-snippet/MarkupSnippet';

interface CTABandDemoProps {
  sectionID?: string;
  classes?: string;
  containerId?: string;
  containerClasses?: string;
  isSpanish?: boolean;
}

const CTABandDemo: React.FC<CTABandDemoProps> = ({
  isSpanish = false,
  sectionID = '',
  classes = '',
  containerId,
  containerClasses,
}) => {
  const t = (en: string, es: string) => (isSpanish ? es : en);

  return (
    <Section {...withOptionalId(sectionID)} className={classes}>
      <Container containerId={containerId} containerClasses={containerClasses}>
        <Heading as='h3'>{t('CTA Band', 'Franja de CTA')}</Heading>
        <p className='sub full'>
          {t(
            'A prominent call-to-action band for demos, downloads, or contact.',
            'Una franja destacada de llamada a la acción para demos, descargas o contacto.'
          )}
        </p>
        <CTABand
          heading={t(
            'Ready to align your study team?',
            '¿Listo para alinear a tu equipo de estudio?'
          )}
          description={t(
            'Get a demo tailored to your protocol and timelines.',
            'Obtén una demo adaptada a tu protocolo y tus cronogramas.'
          )}
          primaryLabel={t('Request a demo', 'Solicitar una demo')}
          primaryHref='mailto:hello@tuliosolorzano.example'
          secondaryLabel={t('Download overview', 'Descargar el resumen')}
          secondaryHref='#'
        />
        <MarkupSnippet
          {...markupCopyLabels(isSpanish)}
          code={`<div class="card cta">
  <div>
    <h3>${t('Ready to align your study team?', '¿Listo para alinear a tu equipo de estudio?')}</h3>
    <p>${t('Get a demo tailored to your protocol and timelines.', 'Obtén una demo adaptada a tu protocolo y tus cronogramas.')}</p>
  </div>
  <div class="row btn-row">
    <a class="btn btn-primary" href="mailto:hello@example.com"><span class="label">${t('Request a demo', 'Solicitar una demo')}</span></a>
    <a class="btn btn-secondary" href="#"><span class="label">${t('Download overview', 'Descargar el resumen')}</span></a>
  </div>
</div>`}
        />
      </Container>
    </Section>
  );
};

export default CTABandDemo;
